var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStakeholderMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 26.7199,
    y1: 9.6135e-9,
    x2: 26.7199,
    y2: 53,
    stroke: "#999999",
    strokeWidth: 0.439864,
    strokeDasharray: "1.76 1.76"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 26.7199,
    x2: 0.0000304984,
    y2: 26.7199,
    stroke: "#999999",
    strokeWidth: 0.439864,
    strokeDasharray: "1.76 1.76"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.20833,
    cy: 2.20833,
    r: 2.20833,
    transform: "matrix(1 0 0 -1 0.883377 17.2249)",
    fill: "#834FF1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.20833,
    cy: 2.20833,
    r: 2.20833,
    transform: "matrix(1 0 0 -1 15.9001 24.7332)",
    fill: "#834FF1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.20833,
    cy: 2.20833,
    r: 2.20833,
    transform: "matrix(1 0 0 -1 24.2918 8.83319)",
    fill: "#834FF1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.20833,
    cy: 2.20833,
    r: 2.20833,
    transform: "matrix(1 0 0 -1 16.7835 17.2249)",
    fill: "#BFA1FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.20833,
    cy: 2.20833,
    r: 2.20833,
    transform: "matrix(1 0 0 -1 4.85847 22.0833)",
    fill: "#BFA1FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.20833,
    cy: 2.20833,
    r: 2.20833,
    transform: "matrix(1 0 0 -1 12.8084 32.2416)",
    fill: "#834FF1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.20833,
    cy: 2.20833,
    r: 2.20833,
    transform: "matrix(1 0 0 -1 4.85847 38.4249)",
    fill: "#3D00C1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.20833,
    cy: 2.20833,
    r: 2.20833,
    transform: "matrix(1 0 0 -1 11.4834 44.6082)",
    fill: "#834FF1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.20833,
    cy: 2.20833,
    r: 2.20833,
    transform: "matrix(1 0 0 -1 24.2918 35.7749)",
    fill: "#3D00C1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.20833,
    cy: 2.20833,
    r: 2.20833,
    transform: "matrix(1 0 0 -1 33.5668 40.6332)",
    fill: "#834FF1"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.20833,
    cy: 2.20833,
    r: 2.20833,
    transform: "matrix(1 0 0 -1 48.1417 41.9582)",
    fill: "#BFA1FF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.20833,
    cy: 2.20833,
    r: 2.20833,
    transform: "matrix(1 0 0 -1 37.1001 32.6832)",
    fill: "#BFA1FF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.20833,
    cy: 2.20833,
    r: 2.20833,
    transform: "matrix(1 0 0 -1 30.4751 22.0833)",
    fill: "#BFA1FF"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.20833,
    cy: 2.20833,
    r: 2.20833,
    transform: "matrix(1 0 0 -1 45.05 20.3166)",
    fill: "#3D00C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeholderMap);
export default __webpack_public_path__ + "static/media/Stakeholder_map.597afbb2dbcd8dc8ba2f2f4c4fa57fd9.svg";
export { ForwardRef as ReactComponent };